import { defineStore } from 'pinia'
import { ref } from 'vue'

const formatDate = (date) => {

  const day = ('0' + date.getDate()).slice(-2)
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const year = date.getFullYear()

  return `${day}-${month}-${year}`
}

export const useGSTCancellationStore = defineStore(
  'gstCancellationStore',
  () => {
    // Store Models
    const gst_cancellation_reason_list = [
      'The entity has never operated on a GST registered basis',
      'The entity is stopping operating on a GST registered basis'
    ]

    const gst_cancellation_day = ref(formatDate(new Date()))
    const gst_cancellation_reason = ref(
      'The entity has never operated on a GST registered basis'
    )

    const resetData = () => {
      gst_cancellation_day.value = formatDate(new Date())
      gst_cancellation_reason.value = 'The entity has never operated on a GST registered basis'
    }

    const update = (order) => {
      gst_cancellation_day.value = order.gst_cancellation.cancellation_day
      gst_cancellation_reason.value = order.gst_cancellation.cancellation_reason
    }

    return {
      gst_cancellation_reason,
      gst_cancellation_reason_list,
      gst_cancellation_day,
      resetData,
      update
    }
  },
  { persist: true }
)
